export default "assets/images/wines-slider-bg-ffcc88f7.png";